/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : NotificationIcon.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useState } from "react";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Notifications from "./Notifications";
import { useNavigate } from "react-router-dom";

const NotificationIcon = () => {
  const navigate = useNavigate();
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [recentNotificationDetails, setRecentNotificationDetails] = useState(
    []
  );

  const handleClose = () => {
    setRecentNotificationDetails([]);
    setNotificationOpen(false);
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={() => {
          navigate("/dashboard/notification");
        }}
      >
        <Badge
          badgeContent={recentNotificationDetails.length}
          color="error"
          invisible={recentNotificationDetails.length === 0}
        >
          <NotificationsIcon sx={{ color: "grey" }} />
        </Badge>
      </IconButton>

      {notificationOpen && (
        <Notifications
          notifications={recentNotificationDetails}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default NotificationIcon;
